import type { MessagingMessage } from "@/model/messaging";
import { filesize } from "filesize";
import { FiDownload } from "react-icons/fi";
import { LuFile } from "react-icons/lu";

export const File = ({ message }: { message: MessagingMessage }) => {
  return (
    <div className="flex flex-row items-center gap-2">
      <div>
        <LuFile className="h-8 w-8" />
      </div>
      <div className="flex flex-col gap-1">
        <span className="max-w-48 truncate">
          {message.payload.media?.mediaName}
        </span>
        {message.payload.media?.mediaSize && (
          <span className="text-xs">
            {filesize(message.payload.media?.mediaSize, {
              standard: "jedec",
            })}
          </span>
        )}
      </div>
      <a
        className="cursor-pointer rounded p-1 hover:opacity-50"
        href={message.payload.media?.mediaUrl}
        target="_blank"
        rel="noreferrer"
      >
        <FiDownload />
      </a>
    </div>
  );
};
